import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemIcon from "@mui/material/ListItemIcon"
import Grid from "@mui/material/GridLegacy"
import Typography from "@mui/material/Typography"
import dynamic from "next/dynamic"
import { isDefined, count, round } from '@components/config/helpers'
import Image from 'next/image'
import useGlobalSettings from '@components/_hooks/useGlobalSettings'
import useWindowSize from '@components/_hooks/useWindowSize'
import P from '@components/Components/Reusables/Typography/P'
import NextIcon from '@mui/icons-material/KeyboardArrowRight';

const ProductCardPriceBreaks = dynamic(() => import('./ProductCardPriceBreaks'))
const ProductVariants = dynamic(() => import('./Variants/ProductVariants'))

const ProductCardKeyFeatures = (props) => {
    const {
        long_term_product,
        key_features,
        price_breaks,
        new_price_breaks,
        product,
        product_variants,
        ecoLeaf = false,
        key_features_md_column = 6,
        promotion_available

    } = props;

    const { getSetting } = useGlobalSettings()
    const { isMobile } = useWindowSize()
    return (
        <>

            <Grid spacing={{ xs: 0, md: 2 }} className={`mb-2 mt-2 w-100 p-0 ${product.package_core_group_id != null ? 'd-none' : ''}`} container>



                {/* Price break To Card */}
                {
                    long_term_product != true && ((isDefined(price_breaks) && count(price_breaks) > 0) || isDefined(new_price_breaks) && Object.keys(new_price_breaks).length > 0) && (
                        <Grid item md={12} lg={12} xl={6} xs={12}>
                            <ProductCardPriceBreaks
                                product={product}
                                long_term_product={long_term_product}
                                price_breaks={price_breaks}
                                new_price_breaks={new_price_breaks}
                                promotion_available={promotion_available}
                            />
                        </Grid>
                    )
                }


                <Grid sx={{ flexDirection: { xs: "column", md: "row" } }} item md={12} lg={12} xl={6} xs={12} >
                    <Grid container spacing={2}>

                        <Grid item xs={12}>
                            {key_features.length > 0 && (
                                <>
                                    <P className="uppercase m-0 p-0 mobile-mt-3" as="h5" color="#333">Key Features</P>
                                    <List>
                                        {key_features?.map((feature, idx) => (
                                            <ListItem key={idx} className={`p-0 align-flex-start`}>
                                                <ListItemIcon sx={{ minWidth: '25px' }}>
                                                    <NextIcon color="primary" />
                                                </ListItemIcon>
                                                <Typography className="f-size_2 pt-0 default-grey " component="span"
                                                    dangerouslySetInnerHTML={{
                                                        __html: feature.value
                                                    }}
                                                >
                                                </Typography>
                                            </ListItem>
                                        ))}
                                    </List>
                                </>
                            )}
                        </Grid>
                    </Grid>


                </Grid>

                <Grid item xs={12}>
                    {/* Eco Leaf Section */}
                    {getSetting('carbon_footprint', 'no') == 'yes' && ecoLeaf &&
                        <Grid className='mt-3' sx={{ width: '90%' }}>
                            <Image
                                src={'/images/eco-leaf-transparent.png'}
                                alt='Eco leaf logo goes here'
                                width={`${!isMobile ? 75 : 50}`}
                                height={`${!isMobile ? 80 : 55}`}
                                className={`f-right ${isMobile ? 'mt-3' : ''}`}
                            />

                            <Typography color='primary' fontSize={17}>Carbon Footprint</Typography>
                            <hr className={`my-4 ${isMobile ? 'f-left' : ''}`} style={{ width: '-webkit-fill-available' }}></hr>
                            <Typography className='default-grey'>
                                Manufacturing this product on average creates <Typography variant='strong' color='primary'>{round(product.carbon[0].co2_total, 2)} kgCO2e</Typography> (kg of carbon dioxide equivalent).
                                Fulfilling your requirements by hiring instead of purchasing, you are looking at a much smaller carbon footprint: <Typography variant='strong' color='primary'>{round(product.carbon[0].co2_net_item, 3)} kgCO2e</Typography>.
                                Thank you for being part of the solution to saving our planet.
                            </Typography>
                        </Grid>
                    }
                </Grid>



            </Grid>
        </>
    )
}

export default ProductCardKeyFeatures